import React from 'react';

import PageContext from '../context';

import * as css       from './footer.module.css';
import * as socialCss from './social.module.css';

import Link from './link';

import gw2   from './img/gw2-logotype.svg';
import boxes from './img/gw2-box.png';

import { i18n } from '../i18n';

const labels = {
    yt : 'YouTube',
    fb : 'Facebook',
    tw : 'Twitter',
    th : 'Twitch',
    ig : 'Instagram',
    tu : 'Tumblr',
    fl : 'Flickr',
    rs : 'RSS'
};

export default function Footer({ nav }) {
    const socialEntries = Object.entries(i18n('social', { md : false }));

    return <PageContext.Consumer>
        {({ gw2Url }) =>
            <footer className={ css.footer }>
                <div>

                    <div className={css.header}>
                        <a href={gw2Url} className={css.logo}>
                            <img src={gw2} alt="Guild Wars 2" />
                        </a>

                        <div className={css.follow}>
                            <ul className={css.social}>
                                {socialEntries.map(([ key, url ]) =>
                                    <li key={key}>
                                        <a href={url} className={socialCss[key]} aria-label={labels[key]}></a>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>

                    <div className={css.navAd}>

                        <nav className={css.nav}>
                            <ul>
                                {nav.format.map(({ id, children }) =>
                                    <li key={id}>
                                        <Link url={nav.data[id].url} title={nav.data[id].title} />

                                        { children ?
                                            <ul>
                                                { children.map(({ id : id2 }) =>
                                                    <li key={id2}>
                                                        <Link url={nav.data[id2].url} title={nav.data[id2].title} />
                                                    </li>
                                                )}
                                            </ul> :
                                            null
                                        }
                                    </li>
                                )}
                            </ul>
                        </nav>

                        <div className={css.ad}>
                            <a href={i18n('footer.ad.url', { md : false })}>
                                <img src={boxes} alt='' />
                                {i18n('footer.ad.label')}
                            </a>
                        </div>

                    </div>

                </div>
            </footer>
        }
    </PageContext.Consumer>;
}
